var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path38, _path39, _path40, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path41, _path42, _path43, _circle, _circle2, _circle3, _circle4, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _circle5, _path54, _path55, _path56, _path57, _path58, _path59, _g, _path60, _path61;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a50fd755-b70f-4e5f-b336-9e50a578b62c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1128.33,
    height: 786.75,
    viewBox: "0 0 1128.33 786.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "be48829d-c862-4d39-810b-ff1fea1d92ea",
    x1: 874.32,
    y1: 843.37,
    x2: 874.32,
    y2: 398.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "booking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M691.54,181.1c-72.31-2.51-141.18-25.86-206.95-51.4S353.68,75.86,283.09,62.33c-45.39-8.71-97.31-9.94-133.89,14.4C114,100.15,102.63,140.58,96.51,178.1c-4.6,28.23-7.3,57.93,5.3,84.36,8.75,18.34,24.29,33.76,35,51.33,37.39,61.15,11,136.54-29.56,196.25-19,28-41.06,54.72-55.72,84.53S30.11,658.54,43,689c12.72,30.14,43,52.78,75.87,68.71C185.51,790,264.1,799.26,340.73,804.5c169.64,11.6,340.19,6.58,510.28,1.55,62.94-1.87,126.17-3.75,188.09-13.49,34.39-5.4,69.89-14,94.86-34.69,31.69-26.29,39.55-70.81,18.31-103.78-35.62-55.3-134.11-69-159-128.38-13.71-32.66.37-69.05,20.29-99.34,42.72-65,114.33-122,118.1-196.29,2.6-51-31.83-102.12-85.06-126.26-55.8-25.3-133.16-22.12-174.33,19.77C829.88,166.72,755.39,183.31,691.54,181.1Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M938.48,738.54a30.82,30.82,0,0,0-12.59-1.34c-5.17.56-4.44,8.43.75,8.06a37.18,37.18,0,0,0,7.66-1.41Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M940.05,738.61a30.77,30.77,0,0,1,3.08,12.29c.17,5.2-7.73,5.57-8.09.38a37.63,37.63,0,0,1,.34-7.78Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M951.81,721.77s-2.53-7.94-18-4.86c-7,1.39-6.81,11.43.2,12.49l.3,0C944.52,730.82,948.07,726.77,951.81,721.77Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M953.42,721.3s8.31.65,8.83,16.4c.24,7.09-9.57,9.24-12.2,2.66,0-.1-.07-.19-.11-.29C946.27,730.46,949.4,726.08,953.42,721.3Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M964.52,701a16.53,16.53,0,0,0-11.16-12.46c-10.47-3.3-16,12.36-5.77,16.34a32.68,32.68,0,0,0,13.24,1.92Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M977.29,674.85s-4.23-10-15.2-12c-11.63-2.13-15.15,15.34-3.66,18.13a38.35,38.35,0,0,0,15.66.13Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M985,649.1a24.82,24.82,0,0,0-16-11c-10-1.88-13.37,13.09-3.55,15.65a37.34,37.34,0,0,0,18.74-.26Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M992.27,624a25.81,25.81,0,0,0-14-11.13c-10-3.07-14.94,12.09-5,15.39a28.47,28.47,0,0,0,18.14-.07Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M995.33,601.13s-4-9.38-12.15-14.34c-9.08-5.53-17.73,8-9,14.09,5.38,3.77,12.27,6.37,20.32,4.63Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M996.84,574s-4.41-9.47-12.87-14c-9.46-5-17.69,8.82-8.78,14.78,5.83,3.89,13.11,6.41,20.84,3.37Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M995.9,549.26a61.35,61.35,0,0,0-12-13.65c-6.62-5.41-15,4.33-8.73,10.11,5.79,5.31,13,9.77,20.45,9.41Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M993.39,525.52A89.9,89.9,0,0,0,979.83,508c-5.18-5-12.84,2.62-8,7.89,5.59,6,13.13,12.22,22.19,14.94Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M988.54,497.6a80.15,80.15,0,0,0-10.83-13.41c-5.22-5.11-13.09,2.58-8.08,7.89,5.32,5.65,12.2,10.94,20.27,12.74Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M984.3,471.55a127.83,127.83,0,0,0-10.41-12.37c-4.18-4.31-10.86,1.75-6.92,6.29,4.63,5.34,10.57,10.07,17.4,10.83Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M979.9,447.39a130.3,130.3,0,0,0-10-16.45c-3.13-4.28-9.65.3-6.7,4.7,3.86,5.77,9.22,11.48,16.26,14.23Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M976.27,415.28s-2.47-4.19-6-9.06c-3.26-4.49-10.14.15-7.12,4.8,3.4,5.21,7.66,9.65,12.62,10.53Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M974.54,394l-3.13-15.65c-.83-4.14-7-3.15-6.5,1,1.12,8.36,4,16.77,10.27,22.29Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M976.4,349.52h0a3.07,3.07,0,0,0-5.86,1.68A79.23,79.23,0,0,0,973.7,364Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M965.22,700.69a16.53,16.53,0,0,1,16.36,3.52c8,7.47-2.82,20-11.35,13.11A32.86,32.86,0,0,1,962,706.77Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M978,673.9s10.52-2.54,18.66,5.08c8.63,8.08-3.3,21.31-12.39,13.74a38.29,38.29,0,0,1-9.43-12.51Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M985.69,650.86a24.83,24.83,0,0,1,19-4.22c10,2,7.51,17.13-2.56,15.84a37.41,37.41,0,0,1-17.28-7.25Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M992.77,624.14a25.78,25.78,0,0,1,17.12-5.11c10.46.91,9.34,16.8-1.13,16.14a28.41,28.41,0,0,1-16.8-6.85Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M995.2,601.78s5.55-8.56,14.41-12.06c9.83-3.89,16.14,10.84,6.59,15.37-6,2.83-13.23,4.26-20.91,1.15Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M995.55,573.59s5.61-8.8,14.58-12.16c10-3.75,16.39,11.05,6.78,15.8-6.29,3.1-13.84,4.64-21.1.62Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M993.67,549a61.32,61.32,0,0,1,8.8-15.9c5.3-6.71,15.61,1,10.69,8-4.52,6.43-10.56,12.32-18,13.57Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M992.9,525.48a89.53,89.53,0,0,1,8.12-20.66c3.59-6.22,13.06-1.07,9.84,5.35-3.68,7.35-9.2,15.4-17.14,20.55Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M987.1,496.3a80.22,80.22,0,0,1,8.26-15.77c4.12-6,13.25-.12,9.48,6.08-4.1,6.76-9.88,13.56-17.63,17Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M982.48,471.41a128.51,128.51,0,0,1,4.33-15.57c2-5.67,10.61-2.93,8.91,2.84-2,6.78-5.43,13.55-11.32,17.08Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M979.27,446.92a129.85,129.85,0,0,1,6-18.31c2.08-4.88,9.48-1.91,7.6,3.05-2.44,6.5-6.36,13.28-12.58,17.56Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M974.46,417.48s.94-4.77,2.65-10.54c1.58-5.32,9.62-3.23,8.31,2.16-1.46,6-4,11.65-8.4,14.13Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M975.58,392.94l5.44-15c1.44-4,7.44-2.06,6.27,2-2.35,8.1-6.43,16-13.48,20.5Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M982.36,351.09s.85-.68,2.15-1.75c2.65-2.2,6.11,1.64,3.61,4a51,51,0,0,1-14.79,9.38Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M982,342.4a197,197,0,0,1,10.85-19.32,2,2,0,0,0-3.24-2.29c-3.2,4.38-6.34,10.79-8.72,20.21Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M975.8,421.8l1.16-.12c-5-46.61-2.89-75.35,5.85-80.92l-.63-1C972.92,345.69,970.72,374.05,975.8,421.8Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#444053"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M993,532l1.73-.26c-.65-4.31-1.4-8.69-2.24-13-7.28-37.83-12.94-72.8-15.77-99.36l-1.27-1c2.84,26.61,8,62.79,15.33,100.67C991.6,523.33,992.35,527.7,993,532Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#444053"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M912,767.58c.26-.21,26.9-20.59,50.29-59.68a252,252,0,0,0,29.6-73.79c7.39-32.51,7.6-70.37,2.27-105.83l-1.56,1.25c12,79.58-10.89,141.37-32.25,177.09-23.16,38.73-49.49,58.9-49.76,59.1Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#444053"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.02,
    cy: 697.97,
    rx: 66.55,
    ry: 12.8,
    fill: "#0b75ce"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.9,
    cy: 692.53,
    rx: 7.75,
    ry: 10.14,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.9,
    cy: 680.13,
    rx: 7.75,
    ry: 10.14,
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.9,
    cy: 667.74,
    rx: 7.75,
    ry: 10.14,
    fill: "#3f3d56"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.9,
    cy: 655.34,
    rx: 7.75,
    ry: 10.14,
    fill: "#3f3d56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.9,
    cy: 642.94,
    rx: 7.75,
    ry: 10.14,
    fill: "#3f3d56"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.9,
    cy: 630.55,
    rx: 7.75,
    ry: 10.14,
    fill: "#3f3d56"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.9,
    cy: 618.15,
    rx: 7.75,
    ry: 10.14,
    fill: "#3f3d56"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M257.74,589.94a36.51,36.51,0,0,0,2.89-4.25l-20.36-3.34,22,.16a37.14,37.14,0,0,0,.71-29.4l-29.54,15.32,27.24-20a37.12,37.12,0,1,0-61.3,41.53,37.49,37.49,0,0,0-4.23,6.77l26.43,13.73L193.42,601a37.13,37.13,0,0,0,6,34.85,37.12,37.12,0,1,0,58.34,0,37.09,37.09,0,0,0,0-45.89Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M191.46,612.89a37,37,0,0,0,7.94,22.94,37.12,37.12,0,1,0,58.34,0C262.72,629.52,191.46,608.72,191.46,612.89Z",
    transform: "translate(-35.84 -56.63)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M267.81,317.87V759.58A15.42,15.42,0,0,0,283.23,775H917.1a15.42,15.42,0,0,0,15.42-15.42V317.87Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 284.57,
    y: 300.78,
    width: 158.9,
    height: 93.27,
    rx: 8.65,
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 484.88,
    y: 300.78,
    width: 158.9,
    height: 93.27,
    rx: 8.65,
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 286.8,
    y: 302.09,
    width: 154.43,
    height: 90.64,
    rx: 8.65,
    fill: "#0b75ce"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 723.26,
    y: 358.72,
    width: 154.43,
    height: 90.64,
    rx: 8.65,
    transform: "translate(1565.11 751.45) rotate(-180)",
    fill: "#444053",
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 522.95,
    y: 358.72,
    width: 154.43,
    height: 90.64,
    rx: 8.65,
    transform: "translate(1164.49 751.45) rotate(-180)",
    fill: "#0b75ce"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 286.8,
    y: 433.02,
    width: 154.43,
    height: 90.64,
    rx: 8.65,
    fill: "#444053",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 723.26,
    y: 489.65,
    width: 154.43,
    height: 90.64,
    rx: 8.65,
    transform: "translate(1565.11 1013.31) rotate(-180)",
    fill: "#444053",
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 522.95,
    y: 489.65,
    width: 154.43,
    height: 90.64,
    rx: 8.65,
    transform: "translate(1164.49 1013.31) rotate(-180)",
    fill: "#444053",
    opacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 286.8,
    y: 563.95,
    width: 154.43,
    height: 90.64,
    rx: 8.65,
    fill: "#444053",
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 723.26,
    y: 620.57,
    width: 154.43,
    height: 90.64,
    rx: 8.65,
    transform: "translate(1565.11 1275.17) rotate(-180)",
    fill: "#444053",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 522.95,
    y: 620.57,
    width: 154.43,
    height: 90.64,
    rx: 8.65,
    transform: "translate(1164.49 1275.17) rotate(-180)",
    fill: "#444053",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M267.81,239.86v80.25H932.52V239.86a15.42,15.42,0,0,0-15.42-15.43H283.23A15.42,15.42,0,0,0,267.81,239.86Zm164.5,23.74a12.31,12.31,0,1,1,12.31-12.31A12.31,12.31,0,0,1,432.31,263.6Zm335.71,0a12.31,12.31,0,1,1,12.31-12.31A12.31,12.31,0,0,1,768,263.6Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M432.31,236.74a14.55,14.55,0,1,0,14.54,14.55A14.54,14.54,0,0,0,432.31,236.74Zm0,26.86a12.31,12.31,0,1,1,12.31-12.31A12.31,12.31,0,0,1,432.31,263.6Z",
    transform: "translate(-35.84 -56.63)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M768,236.74a14.55,14.55,0,1,0,14.55,14.55A14.55,14.55,0,0,0,768,236.74Zm0,26.86a12.31,12.31,0,1,1,12.31-12.31A12.31,12.31,0,0,1,768,263.6Z",
    transform: "translate(-35.84 -56.63)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1033.1,
    cy: 419.94,
    r: 15.27,
    fill: "#0b75ce",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1087.73,
    cy: 351.84,
    r: 25.6,
    fill: "#0b75ce",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1053.84,
    cy: 476.06,
    r: 25.6,
    fill: "#0b75ce",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.25,
    cy: 345.56,
    r: 36.25,
    fill: "#0b75ce",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M961.49,797a32,32,0,0,0-7.42-4.17,1.53,1.53,0,0,0-.65-.17,114.16,114.16,0,0,1-15.3-13.18c1-.8,1.92-1.58,2.9-2.35-6-2.86-9.33-9.41-12.57-15.32a151.14,151.14,0,0,0-33.34-41.54c-.33-1.27-2.26-1-3.29-1.82a2.64,2.64,0,0,1-.73-2.55c.16-.92.58-1.77.81-2.67.55-2.11.07-4.33-.17-6.5s-.14-4.59,1.3-6.21c.46-.53,1.05-.94,1.5-1.48a5.64,5.64,0,0,0,1-4.49,15.94,15.94,0,0,0-1-4.55q7.35-20,14.69-40.07c3.43-9.34,6.89-18.88,7.24-28.84.28-8-1.78-16.31-6.62-22.42.88-.21,1.76-.43,2.63-.68-5.72-7.58-6.34-17.62-6.49-27.17q-.12-7.14-.49-14.29c1.66.73,3.34,1.38,5.06,1.94l1.6.49a55.15,55.15,0,0,0,7.93,1.7c1.18.17,2.38.3,3.57.38h0q-2.58-6.46-5.15-12.94a17.68,17.68,0,0,1-1.6-6.07h0v-.4c0-.24,0-.48.05-.72a7.9,7.9,0,0,1,.39-1.68,7.61,7.61,0,0,1,.31-.79,14,14,0,0,1,1.28-2.25c.36-.55.76-1.08,1.16-1.62a22.11,22.11,0,0,0,3.59-5.81,11,11,0,0,0,.55-3.31,16.29,16.29,0,0,0-.3-3.4c-.14-.74-.32-1.49-.52-2.21h0c-.13-.45-.27-.9-.41-1.34l-.12-.36c-.11-.34-.22-.67-.34-1l-.12-.34c-.13-.36-.26-.71-.4-1.07l-.08-.21c-1.91-4.91-4.45-9.59-6-14.64a38.6,38.6,0,0,1-1-4.09c-.07-.35-.12-.71-.18-1.06s-.09-.6-.13-.9-.09-.7-.13-1.05l-.09-1c0-.32-.05-.64-.07-1,0-.61-.06-1.22-.07-1.83,0-.22,0-.43,0-.65,0-.46,0-.93,0-1.39,0-.25,0-.5,0-.74,0-.46.07-.92.11-1.37,0-.22,0-.44.07-.65q.1-1,.27-2h0c.1-.59.21-1.19.33-1.79a23.88,23.88,0,0,0,.56-5c0-.32,0-.65-.07-1s-.08-.54-.13-.8a2,2,0,0,1,0-.24c0-.18-.09-.36-.13-.54s-.05-.17-.08-.25-.11-.35-.17-.52-.05-.15-.08-.23-.14-.36-.22-.53l-.07-.18c-.1-.22-.21-.43-.32-.64l0,0a14.73,14.73,0,0,0-1.34-2.08h0c-3.29-4.32-8.76-7.61-11.77-12.37a27.54,27.54,0,0,1-3.37-10c-.15-.8-.28-1.6-.42-2.39s-.26-1.57-.4-2.35c-.09-.48-.18-1-.28-1.44l-.06-.31c-.08-.38-.16-.77-.25-1.15l-.06-.27c-.09-.4-.18-.8-.28-1.2l-.06-.21c-.1-.42-.21-.84-.32-1.26a.83.83,0,0,1,0-.15c-.12-.44-.25-.88-.38-1.32l0-.09c-.14-.46-.28-.91-.43-1.36l0,0c-.15-.46-.31-.93-.48-1.39h0c-.18-.47-.35-.94-.54-1.4h0a37,37,0,0,0-5.06-9c-4.58-5.88-11.66-10.1-19-9.82-3.94.15-7.72,1.53-11.43,2.9l-9.63,3.55,2.69-1.24c-2.8.25-5.66.51-8.19,1.75s-4.67,3.67-4.75,6.51c-.05,1.65.6,3.29.39,4.93-.35,2.71-2.84,4.55-4.13,6.95a8.94,8.94,0,0,0-1,4.7V442c0,.19,0,.37,0,.56a.88.88,0,0,0,0,.16l0,.32c-4-1.74-8-3.55-12-5.49-6.61-3.25-13.3-7.07-17.42-13.23-1.32-2-2.34-4.16-3.65-6.14a48.6,48.6,0,0,0-5-6l-12.27-13.28c-.94,1.77.27,3.86,1.22,5.62a24.13,24.13,0,0,1,2.27,5.86,2.78,2.78,0,0,1-.06,2.05,4,4,0,0,1-1.68,1.19,6,6,0,0,0-2.53,6.87,7.6,7.6,0,0,0,5.67,4.94,10.29,10.29,0,0,1,2.53.62c1.48.73,2.18,2.43,3.24,3.7,1.93,2.32,5,3.19,7.93,3.95,4.54,5.24,9.26,10.26,13.8,15.5,6.87,7.93,13.9,16,22.86,21.36.93.56,1.88,1.08,2.84,1.56,0,.16,0,.32-.05.48a5.42,5.42,0,0,0,.43,3.5c.8,1.27,2.45,1.65,3.92,1.91l6.78,1.21a23.16,23.16,0,0,1-.33,2.62c-.09.53-.2,1.05-.3,1.58h0l-.12.68s0,.07,0,.1,0,.36-.07.55,0,.13,0,.19l0,.48v.2c0,.21,0,.43,0,.65.23,2.66,2,4.86,3.77,6.89l.95,1.15a16,16,0,0,0-3.09,6.48,22,22,0,0,0-.44,4.51,7.83,7.83,0,0,0-2,3.12,14.26,14.26,0,0,0-.52,5.05v.12c0,.63,0,1.25,0,1.88a16.8,16.8,0,0,0,1.16,7c.09.18.19.34.28.51-1.5,2.94-4,5.23-5.79,8a17.36,17.36,0,0,0,1.59,19.88c1.37,1.58,3.13,3.1,3.29,5.2a19.51,19.51,0,0,1-.28,2.84c-.16,2.26.88,4.4,1.44,6.59.47,1.82.49,4-.55,5.46a8,8,0,0,0-1.37,5.24c.51,2.83-.66,5.66-.86,8.53-.09,1.23,0,2.48-.11,3.71a20.91,20.91,0,0,1-.73,3.48c0,.12-.06.25-.1.38-2.47,1.09-4.92,2.22-7.28,3.53a6.39,6.39,0,0,0-3,2.76,7.08,7.08,0,0,0-.16,3.8l2.13,14.82-.37-.16q.25,3.64.52,7.31c.13,1.85.3,3.81,1.4,5.29a13.78,13.78,0,0,1,1.51,1.93c.84,1.7-.16,3.68-.9,5.42s-1,4.21.63,5.15a13.29,13.29,0,0,0,2.73,1.46c-2,8.34-.16,17.08,1.7,25.45q2.13,9.6,4.27,19.18a46.54,46.54,0,0,1,.94,8.24c0,.4,0,.8,0,1.2a46.16,46.16,0,0,0,2,11.22c2.22,7.48.09,16.46.79,24.61a73,73,0,0,0,2.34,11.59c4.83,19.16,9.14,37.94,10.8,57.64a14.48,14.48,0,0,0,6.92,4.83c-.2,2.42.07,5.19,0,6.6a11.4,11.4,0,0,1-.54,3.44c-.85,2.22-3,3.67-5.23,4.45-.7.24-1.41.43-2.13.6l.8-.68A17.86,17.86,0,0,0,855,824.31a5.27,5.27,0,0,0-2.63,3.1,5,5,0,0,0,.92,3.59,16.37,16.37,0,0,0,9.25,6.57,48.52,48.52,0,0,0,11.4,1.59l7.06.41a1.94,1.94,0,0,0,.46,2.51,4.94,4.94,0,0,0,2.59.94,33,33,0,0,0,8.71.13,3.41,3.41,0,0,0,2-.72,1.29,1.29,0,0,0,0-1.91,2.11,2.11,0,0,0,1.92-1.4,5.68,5.68,0,0,0,.26-2.53c-.19-3.29-.48-8.07-2.19-11a2.79,2.79,0,0,0-3.09-1.36,120,120,0,0,1-2-17.74,43.33,43.33,0,0,0,5.14-2.32c-4.91-7.93-5-18-3.5-27.22a82.46,82.46,0,0,0,1.31-8.81c.33-5.9-.56-12.58-3.83-17.46a62.47,62.47,0,0,1,15.6,14.12c6.91,9,11.12,19.9,19.59,27.4q1.67-1.63,3.38-3.24,2.68,4.54,5.07,9.27a35.26,35.26,0,0,1,2.94,7.31,33.81,33.81,0,0,1,.27,11.79q-.35,3.12-.85,6.21a16.9,16.9,0,0,1-.61,2.6,1.8,1.8,0,0,0-.19-.78c-.53-.93-2-.51-2.8.13a12.36,12.36,0,0,0-3.45,4,4.31,4.31,0,0,0-.62,2.55,3.77,3.77,0,0,0,2,2.5c3.71,2.17,8.37.6,12.35-1a14.49,14.49,0,0,0,3.12-1.57c2-1.44,3.09-3.81,5.08-5.21a29.43,29.43,0,0,0,3.07-1.94c1.85-1.69,2-4.54,3.35-6.68,2.24-3.69,7.25-4.64,9.21-8.55C967.56,805.27,964.91,799.82,961.49,797Z",
    transform: "translate(-35.84 -56.63)",
    fill: "url(#be48829d-c862-4d39-810b-ff1fea1d92ea)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M875.28,814.6a11.15,11.15,0,0,1-.55,3.4c-.84,2.19-3,3.62-5.22,4.39s-4.58,1-6.84,1.67a6,6,0,0,0-2.67,1.38c-2,2-.8,5.6,1.54,7.09s5.32,1.44,8.1,1.25a106.69,106.69,0,0,0,17.52-2.49c2.08-.49,4.51-1.45,4.84-3.56a5.84,5.84,0,0,0-.16-2A118.21,118.21,0,0,1,889.59,804c0-.48-11.6-.79-12.68-.09C874.49,805.5,875.41,812.14,875.28,814.6Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#a1616a"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M927,789.13q2.88,4.77,5.41,9.73a34.45,34.45,0,0,1,2.94,7.21,33.14,33.14,0,0,1,.27,11.63q-.35,3.07-.86,6.13c-.33,2-.86,4.27-2.57,5.42a5.92,5.92,0,0,0,5.1.45,14.69,14.69,0,0,0,4.49-2.75c8.57-7.07,15-17.34,15.32-28.45a4.51,4.51,0,0,0-.47-2.52,5,5,0,0,0-1.5-1.34,115.25,115.25,0,0,1-17.73-14.89,2.17,2.17,0,0,0-1.3-.83,2.25,2.25,0,0,0-1.16.33c-3.29,1.65-8.79,4-10.16,7.75A5.24,5.24,0,0,1,927,789.13Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#a1616a"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M887,826.21c-7.2,3-15,4.08-22.79,5.11-1,.12-2.07.2-2.73-.5a2.08,2.08,0,0,1-.18-2.34,6.1,6.1,0,0,1,1.67-1.84l5.17-4.33A18,18,0,0,0,855,824.57a5.23,5.23,0,0,0-2.62,3,4.88,4.88,0,0,0,.92,3.55,16.34,16.34,0,0,0,9.24,6.48,49.4,49.4,0,0,0,11.39,1.57l7,.4a1.89,1.89,0,0,0,.47,2.48A5,5,0,0,0,884,843a33.34,33.34,0,0,0,8.7.12,3.33,3.33,0,0,0,2-.71,1.26,1.26,0,0,0,0-1.88,2.11,2.11,0,0,0,1.92-1.39,5.79,5.79,0,0,0,.26-2.49c-.19-3.24-.48-8-2.19-10.83S889.42,825.21,887,826.21Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#3f3d56"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M961.31,797.62a32.17,32.17,0,0,0-7.42-4.11.88.88,0,0,0-1.34.34,76.13,76.13,0,0,0-10.93,21.07c-1.43,4.3-2.56,8.88-5.46,12.36-.38.46-1,.93-1.52.66-.75-.38-.29-1.59-.71-2.32-.52-.92-1.94-.5-2.79.13a12,12,0,0,0-3.44,4,4,4,0,0,0-.62,2.51,3.7,3.7,0,0,0,1.95,2.46c3.71,2.15,8.37.6,12.34-1a14.12,14.12,0,0,0,3.11-1.55c2-1.41,3.09-3.76,5.08-5.13a29.27,29.27,0,0,0,3.07-1.92c1.84-1.67,2-4.48,3.34-6.6,2.24-3.63,7.25-4.57,9.21-8.43C967.37,805.78,964.73,800.4,961.31,797.62Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#3f3d56"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M905.5,597.87c7.86,5.9,11.16,16.39,10.81,26.21s-3.8,19.24-7.22,28.45q-7.35,19.77-14.68,39.53a16.3,16.3,0,0,1,1,4.5,5.53,5.53,0,0,1-1,4.42c-.46.53-1,.94-1.5,1.46-1.44,1.6-1.53,4-1.3,6.13s.72,4.33.17,6.41c-.23.89-.65,1.73-.81,2.63a2.61,2.61,0,0,0,.73,2.52c1,.8,3,.54,3.29,1.8a149.46,149.46,0,0,1,33.3,41c3.24,5.83,6.51,12.29,12.56,15.11a219.28,219.28,0,0,0-16.93,14.89c-8.45-7.4-12.66-18.17-19.56-27A62,62,0,0,0,888.78,752c3.27,4.81,4.16,11.41,3.83,17.22a79.91,79.91,0,0,1-1.31,8.69c-1.55,9.1-1.41,19,3.5,26.86-5.24,2.72-11.26,4.74-17.11,3.93a14.56,14.56,0,0,1-9.32-5.32c-1.66-19.44-6-38-10.79-56.87A69.91,69.91,0,0,1,855.25,735c-.7-8,1.43-16.9-.8-24.28a45.27,45.27,0,0,1-2-11.06c0-.4,0-.79,0-1.19a45.32,45.32,0,0,0-.94-8.12l-4.26-18.92c-1.86-8.27-3.72-16.89-1.71-25.12a13.35,13.35,0,0,1-2.72-1.43c-1.63-.93-1.37-3.36-.63-5.08s1.73-3.67.9-5.35a13.06,13.06,0,0,0-1.51-1.91c-1.1-1.46-1.27-3.39-1.4-5.21l-.52-7.22a14.13,14.13,0,0,1,7.12,6.23c-3.94-6.1-2-14.8.91-21.46a9.78,9.78,0,0,1,9.18-7.27C872.9,594.87,892.48,588.08,905.5,597.87Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#3f3d56"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M898.19,638.93s-7.88,5.26-7.88,9.2-2,39.4-2,39.4v25s1.31,13.14,0,16.42,0,18.39,0,20.36,2-20.36,2-20.36V705.27l2-53.86Z",
    transform: "translate(-35.84 -56.63)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M854.24,456.79,849.65,455c-9.38-3.76-18.77-7.53-27.85-11.94-6.6-3.21-13.29-7-17.4-13.05-1.32-2-2.34-4.1-3.65-6.07a48.42,48.42,0,0,0-5-5.93l-12.26-13.1c-.94,1.75.26,3.81,1.22,5.54a24,24,0,0,1,2.27,5.79,2.68,2.68,0,0,1-.07,2,3.89,3.89,0,0,1-1.67,1.18,5.87,5.87,0,0,0-2.53,6.77,7.55,7.55,0,0,0,5.66,4.88,10.75,10.75,0,0,1,2.53.61c1.48.73,2.18,2.4,3.24,3.65,1.93,2.29,5,3.16,7.92,3.9,4.54,5.17,9.25,10.12,13.79,15.29,6.86,7.82,13.88,15.78,22.84,21.08A33.45,33.45,0,0,0,849,479.74,167.08,167.08,0,0,1,854.24,456.79Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#a1616a"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M854.24,456.79,849.65,455c-9.38-3.76-18.77-7.53-27.85-11.94-6.6-3.21-13.29-7-17.4-13.05-1.32-2-2.34-4.1-3.65-6.07a48.42,48.42,0,0,0-5-5.93l-12.26-13.1c-.94,1.75.26,3.81,1.22,5.54a24,24,0,0,1,2.27,5.79,2.68,2.68,0,0,1-.07,2,3.89,3.89,0,0,1-1.67,1.18,5.87,5.87,0,0,0-2.53,6.77,7.55,7.55,0,0,0,5.66,4.88,10.75,10.75,0,0,1,2.53.61c1.48.73,2.18,2.4,3.24,3.65,1.93,2.29,5,3.16,7.92,3.9,4.54,5.17,9.25,10.12,13.79,15.29,6.86,7.82,13.88,15.78,22.84,21.08A33.45,33.45,0,0,0,849,479.74,167.08,167.08,0,0,1,854.24,456.79Z",
    transform: "translate(-35.84 -56.63)",
    opacity: 0.15
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M845.84,482.9c-1.47-.26-3.12-.62-3.92-1.88a5.27,5.27,0,0,1-.43-3.45,96.76,96.76,0,0,1,5-22.1c2.23,4.13,6.62,6.54,10.78,8.71a80,80,0,0,0,11.58,5.28c-1-.32-3.45,15.06-4.83,16-1.74,1.22-5.94-.43-7.87-.76Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 820.65,
    cy: 400.71,
    r: 21.02,
    fill: "#a1616a"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M852.22,474.74s13.79,11.82,7.88,19.7-9.2,13.14-1.32,13.8,34.15-13.14,34.15-13.14-24.3-19.7-20.36-31.52S852.22,474.74,852.22,474.74Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#fbbebe"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M865.45,493.24a16.31,16.31,0,0,0-12.07,12.14c-1.55,7.08,1.74,15-1.36,21.52-1.46,3.1-4.17,5.42-6,8.33a17,17,0,0,0,1.58,19.61c1.37,1.56,3.13,3.07,3.29,5.13a18.84,18.84,0,0,1-.28,2.8c-.16,2.23.88,4.35,1.44,6.51.47,1.79.49,3.94-.55,5.38a7.79,7.79,0,0,0-1.36,5.17c.5,2.8-.67,5.59-.87,8.42-.09,1.22,0,2.44-.11,3.66a21.35,21.35,0,0,1-.72,3.43l-1.76,6.49c9.54,4.08,19.68,5.55,30,5.36,9.24-.18,18.35-2.09,27.39-4,2.75-.58,5.5-1.16,8.21-1.91-5.72-7.48-6.33-17.39-6.49-26.8a400.06,400.06,0,0,0-3.51-46.9c2.77-5.23,4-11.06,5.14-16.87a28.53,28.53,0,0,0,.64-7.13c-.28-5-2.58-9.75-4.83-14.28-2.06-4.14-4.29-8.5-8.88-10.29a7.06,7.06,0,0,0-6.83.75c-3.47,2.62-2.44,7.14-3.33,11-1.17,5-5.78,8.59-10.69,10a34.75,34.75,0,0,1-11.24,1.05,2,2,0,0,1-1.42-3.28C862.45,496.75,864.07,494.94,865.45,493.24Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M881.73,574.49c-7.78,6.36-15.65,12.78-24.63,17.28-5.27,2.64-10.87,4.59-16,7.43a6.39,6.39,0,0,0-3,2.72,6.72,6.72,0,0,0-.16,3.75l2.28,15.72c.63,4.26,4.72,7,8,9.72-.18-1.43-.47-2.54.21-3.81a12.8,12.8,0,0,1,.77-1.15c1.4-2.12,1.45-4.87,1.11-7.39s-1-5-.87-7.58a2.48,2.48,0,0,1,1.06-2.2c11.17-5.37,23.2-9.49,34.49-14.59a36.55,36.55,0,0,0,8.37-4.75,12.88,12.88,0,0,0,4.86-8.07,1.58,1.58,0,0,0-.2-1.23,1.67,1.67,0,0,0-.85-.5C892.11,578,886.77,576.31,881.73,574.49Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#a1616a"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M860.12,508.53c-3.86.65-7.92,2.65-9.23,6.35a14.11,14.11,0,0,0-.52,5,16.26,16.26,0,0,0,1.17,6.93,19.57,19.57,0,0,0,2.34,3.4c9.24,11.84,13.88,26.71,22.88,38.74.8,1.06,2.26,2.44,1.81,3.69a8.94,8.94,0,0,0-.43,1,2,2,0,0,0,.66,1.75,4.27,4.27,0,0,1,1.09,1.59c.17.63-.25,1.45-.9,1.4,1.08,3.34,4.39,5.29,7.53,6.87,5.22,2.63,11,4.7,16.81,4.13,1.09-4.37,2.61-9.31,2-13.76a35.72,35.72,0,0,0-3.35-9.76l-3.91-8.54c-3.33-7.29-6.69-14.63-11.33-21.16a32,32,0,0,1-4.19-6.75c-1.19-3.09-4.46-5.26-6.44-7.91-2.94-4-6-8-9.94-10.89C864.59,509.39,862.05,508.21,860.12,508.53Z",
    transform: "translate(-35.84 -56.63)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M860.12,506.56c-3.86.65-7.92,2.65-9.23,6.34a14.19,14.19,0,0,0-.52,5,16.26,16.26,0,0,0,1.17,6.93,19.57,19.57,0,0,0,2.34,3.4c9.24,11.84,13.88,26.71,22.88,38.74.8,1.06,2.26,2.44,1.81,3.69a8.94,8.94,0,0,0-.43,1,2,2,0,0,0,.66,1.75,4.27,4.27,0,0,1,1.09,1.59c.17.63-.25,1.45-.9,1.4,1.08,3.34,4.39,5.29,7.53,6.87,5.22,2.63,11,4.7,16.81,4.13,1.09-4.37,2.61-9.31,2-13.76a35.72,35.72,0,0,0-3.35-9.76l-3.91-8.54c-3.33-7.29-6.69-14.63-11.33-21.16a31.84,31.84,0,0,1-4.19-6.76c-1.19-3.08-4.46-5.25-6.44-7.9-2.94-4-6-8-9.94-10.89C864.59,507.42,862.05,506.24,860.12,506.56Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#0b75ce"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M851.31,422.81c-2.79.24-5.66.5-8.18,1.72s-4.67,3.62-4.75,6.42c0,1.63.6,3.25.39,4.86-.35,2.68-2.84,4.49-4.12,6.86-2.24,4.12-.5,9.36,2.4,13s6.83,6.44,9.81,10.06a26,26,0,0,1,5.42,20.92,16.6,16.6,0,0,0-.53,4.37c.23,2.62,2,4.79,3.76,6.79a313.68,313.68,0,0,1,23.72,31.56,85.27,85.27,0,0,1,5.84,10c1.7,3.58,3,7.4,5.36,10.57a27.91,27.91,0,0,0,7.87,6.75,55.58,55.58,0,0,0,25.2,8.13l-5.15-12.77c-.91-2.27-1.85-4.66-1.55-7.09.57-4.6,5.21-7.62,6.72-12,1-2.82.55-5.93-.27-8.8-1.82-6.47-5.46-12.29-7.42-18.72a38,38,0,0,1-1.12-17.41c.43-2.56,1.13-5.13.81-7.7-.95-7.82-10.12-11.56-14.36-18.19-2.74-4.26-3.27-9.51-4.19-14.49-1.33-7.27-3.7-14.53-8.28-20.33s-11.64-10-19-9.69c-3.94.15-7.71,1.52-11.42,2.86L848.63,424",
    transform: "translate(-35.84 -56.63)",
    fill: "#3f3d56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M894.34,439.14c.83,4.49,1.35,9.2,3.45,13.21-.29-1.56-.53-3.13-.82-4.67a58.24,58.24,0,0,0-3.22-11.46C894,437.19,894.17,438.16,894.34,439.14Z",
    transform: "translate(-35.84 -56.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.08,479.52a38.19,38.19,0,0,0,1.12,17.42c.47,1.53,1,3,1.64,4.5a38.07,38.07,0,0,1-.13-13.38c.43-2.56,1.13-5.13.81-7.7a12,12,0,0,0-2.6-6C912.77,476.1,912.37,477.81,912.08,479.52Z",
    transform: "translate(-35.84 -56.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.25,524.19a48.27,48.27,0,0,0-2-5.52,12.27,12.27,0,0,1-.38,5.78c-1.51,4.37-6.16,7.4-6.72,12-.3,2.43.63,4.82,1.55,7.09.34.85.68,1.71,1,2.56a8.24,8.24,0,0,1,0-1.11c.57-4.6,5.21-7.62,6.72-12C924.5,530.17,924.07,527.06,923.25,524.19Z",
    transform: "translate(-35.84 -56.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.68,548.18a28,28,0,0,1-7.87-6.76c-2.37-3.17-3.67-7-5.37-10.57a84.33,84.33,0,0,0-5.84-10,314.08,314.08,0,0,0-23.71-31.57c-.31-.35-.61-.71-.91-1.07a10.28,10.28,0,0,0-.23,2.82c.23,2.62,2,4.79,3.76,6.79a313.68,313.68,0,0,1,23.72,31.56,85.27,85.27,0,0,1,5.84,10c1.7,3.58,3,7.4,5.36,10.57a27.91,27.91,0,0,0,7.87,6.75,55.58,55.58,0,0,0,25.2,8.13L920,556.23A55.64,55.64,0,0,1,895.68,548.18Z",
    transform: "translate(-35.84 -56.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.23,457.23c-3-3.62-6.91-6.37-9.81-10.05-.26-.34-.51-.69-.76-1.06a14.56,14.56,0,0,0,3.39,9.59c2.9,3.69,6.83,6.44,9.81,10.06a25,25,0,0,1,3,4.56A26,26,0,0,0,844.23,457.23Z",
    transform: "translate(-35.84 -56.63)"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M453.88,354.58l-7.25-7.29a3.85,3.85,0,0,0-5.47,0L395.63,392.4,376.37,373a3.84,3.84,0,0,0-5.43,0l-7.33,7.25a3.89,3.89,0,0,0,0,5.47l29.25,29.47a3.88,3.88,0,0,0,5.46,0l55.56-55.14A3.85,3.85,0,0,0,453.88,354.58Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#3acc6c"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M654.88,354.58l-7.25-7.29a3.85,3.85,0,0,0-5.47,0L596.63,392.4,577.37,373a3.84,3.84,0,0,0-5.43,0l-7.33,7.25a3.89,3.89,0,0,0,0,5.47l29.25,29.47a3.88,3.88,0,0,0,5.46,0l55.56-55.14A3.85,3.85,0,0,0,654.88,354.58Z",
    transform: "translate(-35.84 -56.63)",
    fill: "#3acc6c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures4);
export default __webpack_public_path__ + "static/media/features-4.ea5367f92e103256be4b4a236d93b9ba.svg";
export { ForwardRef as ReactComponent };